module.exports = __webpack_public_path__ + "img/desktop-neck-5_18x392.8b686c3b.png";